<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="mob-container">
  <div class="title-wrapper mb-4">
    <div>
      <h1 class="title-default">Inventário</h1>
      <p class="welcome-message">
        <button mat-icon-button type="button" (click)="host.cancelar()" aria-label="Voltar">
          <mat-icon>arrow_back</mat-icon>
        </button>
        Ajustar saldo de estoque do dia
      </p>
    </div>
  </div>

  @if (host._isLoading) {
  <div class="mob-loading">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
  </div>
  } @else {

  @if (host.isReadOnly) {
  <div class="mob-readonly">Inventário somente leitura.</div>
  }

  @if (host.idStatusInventario === _StatusInventarioEnum.Falha && host.mensagemProcessamento) {
  <div class="mob-falha-banner">Falha no processamento: {{ host.mensagemProcessamento }}</div>
  }

  <!-- Cabeçalho compacto -->
  <form [formGroup]="host.formInventario" class="mob-form">
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="descricao" placeholder="Ex.: Balanço" required />
      @if (host.formInventario.get('descricao')?.touched && host.formInventario.get('descricao')?.invalid) {
      <mat-error>Informe a descrição do inventário</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100 mob-local-field" subscriptSizing="dynamic">
      <mat-label>Locais de estoque</mat-label>
      <mat-select formControlName="idsLocalizacoes" multiple required>
        @for (loc of host.listaLocalizacoes; track loc.id) {
        <mat-option [value]="loc.id">{{ loc.descricao }}</mat-option>
        }
      </mat-select>
      @if (host.formInventario.get('idsLocalizacoes')?.touched && host.formInventario.get('idsLocalizacoes')?.invalid) {
      <mat-error>Selecione ao menos uma localização</mat-error>
      }
    </mat-form-field>

    <div class="mob-form-row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Responsável</mat-label>
        <mat-select formControlName="idUsuarioResponsavel" required>
          @for (u of host.listaUsuarios; track u.idUsuario) {
          <mat-option [value]="u.idUsuario">{{ u.nomeUsuario }}</mat-option>
          }
        </mat-select>
        @if (host.formInventario.get('idUsuarioResponsavel')?.touched &&
        host.formInventario.get('idUsuarioResponsavel')?.invalid) {
        <mat-error>Selecione o responsável</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="dataInventario" (input)="onDateInput($event)"
          (keydown)="onDateKeydown($event)" (blur)="onDataInventarioBlur($event)" placeholder="DD/MM/AAAA"
          inputmode="numeric" maxlength="10" [max]="hoje" required />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (host.formInventario.get('dataInventario')?.touched && host.formInventario.get('dataInventario')?.invalid) {
        <mat-error>Informe a data</mat-error>
        }
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Motivo (opcional)</mat-label>
      <textarea matInput rows="2" formControlName="motivo"></textarea>
    </mat-form-field>
  </form>

  <!-- Ações principais -->
  @if (!host.isReadOnly) {
  <div class="mob-acoes">
    <button mat-flat-button class="btn-primary mob-btn-leitor" type="button" (click)="abrirLeitor()">
      <mat-icon>qr_code_scanner</mat-icon>
      Abrir leitor
    </button>

    <button mat-stroked-button class="btn-secondary btn-section" type="button" (click)="abrirAdicionarProduto()">
      <mat-icon>add_circle_outline</mat-icon>
      Adicionar produto
    </button>
  </div>
  }

  <!-- Filtros -->
  <mat-form-field appearance="outline" class="mob-filtro-select w-100">
    <mat-label>Filtrar por</mat-label>
    <mat-select [(ngModel)]="filtroAtivo">
      @for (f of filtros; track f.chave) {
      <mat-option [value]="f.chave">{{ f.rotulo }} ({{ contar(f.chave) }})</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Cards -->
  @if (cardsFiltrados.length === 0) {
  <app-empty-list [title]="'Nenhum item'"
    [subTitle]="'Use o leitor ou adicione um produto manualmente para registrar contagens.'"></app-empty-list>
  } @else {
  <div class="mob-cards">
    @for (c of cardsFiltrados; track c.produto.idProduto) {
    <div class="mob-card" role="button" tabindex="0" (click)="abrirCard(c)" (keydown.enter)="abrirCard(c)">
      <div class="mob-card-top">
        <span class="mob-card-nome">{{ c.produto.nome }}</span>
        <div class="mob-card-top-actions">
          @if (c.temLoteSerie) {
          <span class="mob-badge" [class.rastreabilidade-pendente]="c.rastreabilidadePendente"
            [class.rastreabilidade-confirmada]="c.rastreabilidadeConfirmada">
            {{ c.produto.isControlaLotes ? 'Lotes' : 'Séries' }}
            {{ c.rastreabilidadeConfirmada ? 'confirmados' : 'pendentes' }}
          </span>
          }
          @if (!host.isReadOnly) {
          <button type="button" class="mob-card-remover"
            (click)="$event.stopPropagation(); host.removerProduto(c.produto.idProduto)" aria-label="Remover produto"
            matTooltip="Remover produto">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
          }
        </div>
      </div>
      <div class="mob-card-sub">{{ c.produto.sku ? 'SKU: ' + c.produto.sku : '—' }}</div>
      <div class="mob-card-bottom">
        @if (c.todosContados) {
        <span class="mob-status lancado">Lançado</span>
        } @else if (c.algumContado) {
        <span class="mob-status parcial">Parcial</span>
        } @else {
        <span class="mob-status pendente">Pendente</span>
        }
        <span class="mob-card-qtd">Contado: <strong>{{ c.totalContado | abnt:'quantidade' }}</strong> {{
          c.produto.unidade }}</span>
        @if (c.algumContado && c.ajusteTotal !== 0) {
        <span class="mob-ajuste" [class.neg]="c.ajusteTotal < 0">{{ c.ajusteTotal > 0 ? '+' : '' }}{{ c.ajusteTotal |
          abnt:'quantidade' }}</span>
        }
      </div>
    </div>
    }
  </div>
  }
  }
</div>

<!-- Footer -->
@if (!host.isReadOnly && !host._isLoading) {
<app-footer-action cancelarLabel="Cancelar" salvarLabel="Concluir inventário" [isLoadingSalvar]="host.isConcluindo"
  [isSalvarDisabled]="salvarDesabilitado" (cancelar)="host.cancelar()" (salvar)="host.concluirInventario()">
  <button mat-stroked-button class="btn-secondary" [disabled]="rascunhoDesabilitado" (click)="host.salvarRascunho()">
    @if (host.isSalvandoRascunho) {
    <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
    } @else {
    Salvar
    }
  </button>
</app-footer-action>
}

<!-- Seleção de múltiplos resultados -->
@if (resultados.length > 0) {
<div class="sheet-backdrop" (click)="resultados = []"></div>
<div class="mob-resultados">
  <div class="mob-resultados-header">
    <span>Selecione o produto</span>
    <button mat-icon-button type="button" (click)="resultados = []"
      aria-label="Fechar"><mat-icon>close</mat-icon></button>
  </div>
  <div class="mob-resultados-lista">
    @for (p of resultados; track p.idProduto) {
    <button type="button" class="mob-resultado" (click)="selecionarProduto(p)">
      <div class="mob-card-top">
        <span class="mob-card-nome">{{ p.descricao }}</span>
        @if (p.isControlaLotes || p.isControlaSeries) {
        <span class="mob-badge">{{ p.isControlaLotes ? 'Lote' : 'Série' }}</span>
        }
      </div>
      <div class="mob-card-sub">{{ p.codigoSku ? 'SKU: ' + p.codigoSku : (p.gtinEan ? 'EAN: ' + p.gtinEan : '—') }}
      </div>
    </button>
    }
  </div>
</div>
}

<!-- Leitor de câmera -->
@if (scannerAberto) {
<app-inventario-scanner-mobile (codigoLido)="onCodigoLido($event)"
  (fechar)="fecharLeitor()"></app-inventario-scanner-mobile>
}

<!-- Painel inferior do item -->
@if (sheetAberto) {
<app-inventario-item-sheet [produto]="sheetProduto" [locaisDisponiveis]="sheetLocais" [isReadOnly]="host.isReadOnly"
  [prefill]="sheetPrefill" [isCarregandoProduto]="sheetCarregandoProduto"
  [permiteSelecionarProduto]="sheetPermiteSelecionarProduto" (produtoSelecionado)="onSheetProdutoSelecionado($event)"
  (confirmar)="onSheetConfirmar($event)" (limpar)="onSheetLimpar()" (fechar)="fecharSheet()">
</app-inventario-item-sheet>
}